export default __webpack_public_path__ + "static/mid-east-513767dd4e66d23c4c73c003a36f8c29.png";